import { useEffect, useRef, useState } from "react";

export default function CinelaserDemo() {
  // ====== CONFIGURAÇÕES - EDITE AQUI ======
  const AGENT_ID = "340aa3cf-eed8-41a0-85c0-7bb409b92dea";
  const API_KEY = "pawsf_6b7f8ef39fad837f3b1802d001d209e0";
  const SITE_URL = "https://ia.solteozap.com.br"; // URL do seu site
  // ========================================

  const iframeRef = useRef(null);
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) || window.innerWidth <= 768;

    const handleMessage = (event) => {
      const iframe = iframeRef.current;
      if (!iframe) return;

      switch (event.data.type) {
        case "agent-chat-resize":
          iframe.style.width = event.data.width;
          iframe.style.height = event.data.height;
          iframe.style.bottom = event.data.bottom;
          iframe.style.right = event.data.right;
          iframe.style.borderRadius = event.data.borderRadius;

          // ✅ Ajuste dinâmico da altura em mobile fullscreen
          if (isMobile && event.data.height === "100vh") {
            const setRealHeight = () => {
              const realHeight = window.visualViewport
                ? `${window.visualViewport.height}px`
                : `${window.innerHeight}px`;
              iframe.style.height = realHeight;
            };

            setRealHeight();

            // Atualiza dinamicamente com scroll/resize
            if (window.visualViewport) {
              window.visualViewport.addEventListener("resize", setRealHeight);
              window.visualViewport.addEventListener("scroll", setRealHeight);
            } else {
              window.addEventListener("resize", setRealHeight);
            }
          }
          break;

        case "agent-chat-opened":
          setIsChatOpen(true);
          break;

        case "agent-chat-closed":
          setIsChatOpen(false);
          break;

        case "agent-chat-ready":
          iframe.contentWindow.postMessage(
            {
              type: "parent-info",
              isMobile,
              screenWidth: window.innerWidth,
            },
            "*"
          );
          break;

        default:
          break;
      }
    };

    window.addEventListener("message", handleMessage);

    // Cleanup ao desmontar o componente
    return () => {
      window.removeEventListener("message", handleMessage);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", () => {});
        window.visualViewport.removeEventListener("scroll", () => {});
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Seu conteúdo da página */}
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Demo Cinelaser
        </h1>
        <p className="text-lg text-gray-600">
          Esta é uma página de demonstração do chat widget para Cinelaser.
        </p>
      </div>

      {/* Chat Widget Iframe */}
      <iframe
        ref={iframeRef}
        id="agent-chat-widget"
        src={`${SITE_URL}/agent-chat/iframe/${AGENT_ID}?apiKey=${API_KEY}`}
        style={{
          position: "fixed",
          border: "none",
          zIndex: 9999,
          bottom: "20px",
          right: "20px",
          transition: "all 0.3s ease",
          borderRadius: "20px",
          overflow: "hidden",
          pointerEvents: "auto",
        }}
        allowTransparency={true}
      />
    </div>
  );
}
